<template>
  <mdb-container fluid>
    <mdb-row>
			<mdb-view class="d-none d-lg-block">
				<img class="img-fluid" src="@/assets/snow-banner.png">
			</mdb-view>
    </mdb-row>
    <mdb-row class="mt-3">
      <mdb-col col="1"></mdb-col>
      <mdb-col md="3">
        <p class="projectTitle">Our Services</p>
        
        <span class="serviceTitle">Groundworks</span>
        <p class="serviceBody">We specialise in a complete range of groundworks. From foundations, drainage installation, utility installation to block paving, tarmac surfacing. We have years of experience working with businesses, landowners and property developers providing specific groundworks packages to suit different projects.</p>
        
        <span class="serviceTitle">Civil Engineering</span>
        <p class="serviceBody">When it comes to civil engineering, Foxdown Construction are experienced in liaising with public authorities, adopting agencies and councils. Construction to make permanent alterations or improvements to a public highway as part of a planning approval is another service that we can offer.</p>
        
        <span class="serviceTitle">Earthworks</span>
        <p class="serviceBody">From the very first day on site, preparing for ground excavation is key to a successful job. Stripping topsoil, clearing any vegetation, and beginning the cut &amp; fill process is what we can offer as part of any development package.</p>
      </mdb-col>

      <mdb-col>
        <video playsinline autoplay loop controls>
          <source src="@/assets/services.mp4" type="video/mp4"> 
        </video>
      </mdb-col>

      <mdb-col col="1"></mdb-col>
    </mdb-row>


    <mdb-row class="mt-4 d-none d-lg-block">
      <mdb-col col="1"></mdb-col>
      <mdb-col class="d-inline-flex justify-content-center">
        <gallery :images="slideshow" :index="index" @close="index = null"></gallery>
        <div
          class="image"
          v-for="(image, imageIndex) in slideshow"
          :key="imageIndex"
          @click="index = imageIndex"
          :style="{ backgroundImage: 'url(' + image + ')', width: '25%', height: '200px' }"
        ></div>
      </mdb-col>
     <mdb-col col="1"></mdb-col>
    </mdb-row>


    <mdb-row class="mt-4 mb-4">
      <mdb-col col="1"></mdb-col>
      <mdb-col>
        <mdb-row>
          <mdb-col>
            <img class="img-fluid" src="@/assets/Accreditations/ssip.png" alt="SSIP" onclick="window.open('https://ssip.org.uk/')" />
          </mdb-col>
          <mdb-col>
            <img class="img-fluid" src="@/assets/Accreditations/smas.png" alt="SMAS" onclick="window.open('https://smasltd.com/')" />
          </mdb-col>
          <mdb-col>
            <img class="img-fluid" src="@/assets/Accreditations/builders_profile.png" alt="Builders Profile" onclick="window.open('https://www.buildersprofile.co.uk/website/')" />
          </mdb-col>
        </mdb-row>
      </mdb-col>
      <mdb-col col="1"></mdb-col>
    </mdb-row>
  </mdb-container>
</template>
<script>
  import VueGallery from 'vue-gallery';
  import { mdbContainer, mdbRow, mdbCol, mdbView } from 'mdbvue';
  export default {
    name: 'Services',
    components: {
      mdbContainer,
      mdbRow,
      mdbCol,
      mdbView,
      'gallery': VueGallery
    },
    mounted() {
    },
    data() {
      return {
        slideshow : [
          require("@/assets/Slideshow/1.png"),
          require("@/assets/Slideshow/2.png"),
          require("@/assets/Slideshow/3.png"),
          require("@/assets/Slideshow/4.png"),
          require("@/assets/Slideshow/5.png"),
          require("@/assets/Slideshow/6.png"),
          require("@/assets/Slideshow/7.png"),
          require("@/assets/Slideshow/8.png")
        ],
        index: null,
      }
    },
    methods: {
      // autoPlay: function() {
      //   let video = document.getElementById("serviceVideo").autoplay = true;
      //   alert("dpone");
      // },
    }
  }
</script>